<div [@fadeInOut]="'in'">
  <div class="question-title" [@fadeInOut]="'in'">
    <h3>{{question.title}}</h3>
    <h5>{{question.instructions}}</h5>
  </div>

  <!-- Text questions -->
  @if (question.type_s == 'text') {
    <div class="question-body" [@fadeInOut]="'in'">
      <textarea placeholder="{{question.optionsText[0] || ''}}" class="form-control text-area-question" rows="5" [(ngModel)]="question.answer"></textarea>
      <div class="send-button">
        <button (click)="answer(question.answer)">{{question.optionsText[1] || 'ENVIAR'}}</button>
      </div>
    </div>
  }
  @if (question.type_s == 'string') {
    <div class="question-body">
      <input placeholder="{{question.optionsText[0] || ''}}" class="form-control" rows="5" [(ngModel)]="question.answer"/>
      <div class="send-button">
        <button (click)="answer(question.answer)">{{question.optionsText[1] || 'ENVIAR'}}</button>
      </div>
    </div>
  }

  <!-- Select questions -->
  @if (question.type_s == 'select') {
    <div class="question-body" [@fadeInOut]="'in'">
      <ng-select  [items]="question.selectOptions"
        bindLabel="label"
        autofocus
        bindValue="value"
        [(ngModel)]="question.answer">
      </ng-select>
      <div class="send-button">
        <button (click)="answer(question.answer)">{{question.optionsText[1] || 'ENVIAR'}}</button>
      </div>
    </div>
  }
  @if (question.type_s == 'multiselect') {
    <div class="question-body" [@fadeInOut]="'in'">
      <ng-select  [items]="question.selectOptions"
        bindLabel="label"
        autofocus
        bindValue="value"
        [(ngModel)]="question.answer"
        multiple="true"
        [maxSelectedItems]="question.maxSelectedItems"
        (change)="onMultiSelectChange($event)">
      </ng-select>
      <div class="send-button">
        <button [disabled]="currentlySelected < question.minSelectedItems" (click)="answerMulti(question.answer)">{{question.optionsText[0] || 'ENVIAR'}}</button>
      </div>
    </div>
  }

  <!-- Menu questions -->
  @if (question.type_s == 'menu') {
    <div class="question-body" [@fadeInOut]="'in'">
      <ul class="menu">
        @for (option of question.selectOptions; track option; let i = $index) {
          <li
            (click)="answer(option.value)"
            class="menu-item">
            <div class="box"><span>{{letters[i]}}</span></div>
            <div class="label"><span>{{option.label}}</span></div>
          </li>
        }
      </ul>
    </div>
  }
  @if (question.type_s == 'multimenu') {
    <div class="question-body" [@fadeInOut]="'in'">
      <ul class="menu">
        @for (option of question.selectOptions; track option; let i = $index) {
          <li [class.disabled]="currentlySelected == question.maxSelectedItems && !option.selected"
            (click)="toggleOptionAnswerArr(option)"
            class="menu-item" [class.selected]="option.selected">
            <div class="box">
              @if (!option.selected) {
                <span>{{letters[i]}}</span>
              }
              @if (option.selected) {
                <span>
                  <fa-icon [icon]="faCheck"></fa-icon>
                </span>
              }
            </div>
            <div class="label"><span>{{option.label}}</span></div>
          </li>
        }
      </ul>
      <div class="send-button">
        <button [disabled]="currentlySelected < question.minSelectedItems" (click)="answerMulti(answerArr)">{{question.optionsText[0] || 'ENVIAR'}}</button>
      </div>
    </div>
  }

  <!-- Rating questions -->
  @if (question.type_s == 'rate0-5') {
    <div class="question-body rating" [@fadeInOut]="'in'">
      <ngx-stars [size]="3" [wholeStars]="true" [color]="'#FFD700'" (ratingOutput)="answer($event.toString())"></ngx-stars>
    </div>
  }

  @if (question.type_s == 'rate0-10') {
    <div class="question-body rating" [@fadeInOut]="'in'">
      <ngx-stars [size]="3" [maxStars]="10" [wholeStars]="true" [color]="'#FFD700'" (ratingOutput)="answer($event.toString())"></ngx-stars>
    </div>
  }

  <!-- Button questions -->
  @if (question.type_s == 'yes-no') {
    <div class="question-body yes-no-container" [@fadeInOut]="'in'">
      <button (click)="answer(question.optionsText[0])">{{question.optionsText[0]}}</button>
      <button (click)="answer(question.optionsText[1])">{{question.optionsText[1]}}</button>
    </div>
  }
  @if (question.type_s == 'yes-no-maybe') {
    <div class="question-body yes-no-maybe-container" [@fadeInOut]="'in'">
      <button (click)="answer(question.optionsText[0])">{{question.optionsText[0]}}</button>
      <button (click)="answer(question.optionsText[1])">{{question.optionsText[1]}}</button>
      <button (click)="answer(question.optionsText[2])">{{question.optionsText[2]}}</button>
    </div>
  }



</div>
